"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _ConfigInfo = _interopRequireDefault(require("./ConfigInfo"));

var _ActionIcon = _interopRequireDefault(require("./ActionIcon"));

var _Content = _interopRequireDefault(require("./Content"));

_ConfigInfo["default"].ActionIcon = _ActionIcon["default"];
_ConfigInfo["default"].Content = _Content["default"];
var _default = _ConfigInfo["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ConfigInfo/index.js
// module id = 2092
// module chunks = 6 7 17 18